import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Login from '../pages/Login';
import RecoverPassword from "../pages/RecoverPassword";
import Register from "../pages/Register";

const AuthRoutes: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/recuperar-senha" element={<RecoverPassword />} />
        <Route path="/cadastrar" element={<Register />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AuthRoutes;
